import { render, staticRenderFns } from "./therapyDetail.vue?vue&type=template&id=bf1a4e4a&scoped=true&"
import script from "./therapyDetail.vue?vue&type=script&lang=js&"
export * from "./therapyDetail.vue?vue&type=script&lang=js&"
import style0 from "./therapyDetail.vue?vue&type=style&index=0&id=bf1a4e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1a4e4a",
  null
  
)

export default component.exports